export default __webpack_public_path__ + "static/media/8.aa9f8f98.webp";